import PatientService from "../../../Services/PatientService";
import { useEffect, useState } from "react";
import StressData from "../../../components/Activities/StressData";
import SleepData from "../../../components/Activities/SleepData";
import StepData from "../../../components/Activities/StepData";
import CaloriesData from "../../../components/Activities/CaloriesData";
import HRVData from "../../../components/Activities/HRVData";
import BatteryData from "../../../components/Activities/BatteryData";

export default function Activities() {
  const patJson = localStorage.getItem("patientData");
  const patObj = patJson ? JSON.parse(patJson) : null;
  const [smartWatchId, setSmartWatchId] = useState("");

  useEffect(() => {
    getSmartWatchId();
  }, []);

  const getSmartWatchId = async () => {
    try {
      const patientRes = await PatientService.getPatient({
        patientId: patObj.patientId,
      });
      const userId = patientRes?.data?.[0]?.smartWatchUserId;
      if (!userId) return;
      setSmartWatchId(userId);
    } catch (error) {}
  };

  return (
    <div className="mt-3">
      {smartWatchId && (
        <div className="grid grid-cols-5 px-2">
          <div className="my-2 w-64">
            <StressData />
          </div>
          <div className="my-2 w-64">
            <SleepData />
          </div>
          <div className="my-2 w-64">
            <StepData />
          </div>
          <div className="my-2 w-64">
            <CaloriesData />
          </div>
          <div className="my-2 w-64">
            <BatteryData />
          </div>
          <div className="my-2 w-64">
            <HRVData />
          </div>
        </div>
      )}
    </div>
  );
}
